import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import ParticipantChat from "@/pages/ParticipantChat";
import { SignInPage, SignUpPage } from "@/pages/admin/AuthPages";
import AdminLayout from "@/pages/admin/AdminLayout";
import Inbox from "@/pages/admin/Inbox";
import Home from "@/pages/admin/Home";
import SettingsPage from "@/pages/admin/SettingsPage";
import Library from "@/pages/admin/Library";
import Participants from "@/pages/admin/Participants";
import Receipts from "@/pages/admin/Receipts";
import Categories from "@/pages/admin/Categories";
import PixSettings from "@/pages/admin/PixSettings";
import Reports from "@/pages/admin/Reports";
import Team from "@/pages/admin/Team";
import Help from "@/pages/admin/Help";
import Broadcasts from "@/pages/admin/Broadcasts";
import Privacy from "@/pages/Privacy";

function ClerkShell() {
  return (
    <ClerkAuthProvider>
      <Outlet />
    </ClerkAuthProvider>
  );
}

function LegacyAuth({ to }) {
  const { pathname, search, hash } = useLocation();
  const rest = pathname.replace(/^\/sign-(in|up)/, "");
  return <Navigate to={`${to}${rest}${search}${hash}`} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ParticipantChat />} />
        <Route path="/privacidade" element={<Privacy />} />
        <Route element={<ClerkShell />}>
          <Route path="/sign-in/*" element={<LegacyAuth to="/admin/entrar" />} />
          <Route path="/sign-up/*" element={<LegacyAuth to="/admin/cadastro" />} />
          <Route path="/admin/entrar/*" element={<SignInPage />} />
          <Route path="/admin/cadastro/*" element={<SignUpPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Home />} />
            <Route path="conversas" element={<Inbox />} />
            <Route path="configuracoes" element={<SettingsPage />} />
            <Route path="participantes" element={<Participants />} />
            <Route path="comprovantes" element={<Receipts />} />
            <Route path="categorias" element={<Categories />} />
            <Route path="pix" element={<PixSettings />} />
            <Route path="relatorios" element={<Reports />} />
            <Route path="respostas" element={<Library />} />
            <Route path="equipe" element={<Team />} />
            <Route path="ajuda" element={<Help />} />
            <Route path="transmissoes" element={<Broadcasts />} />
          </Route>
        </Route>
      </Routes>
      <Toaster position="top-center" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
